import React, { memo, useMemo } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { shortenString } from '../../../utils/parsing';
import { cellText } from '../../../utils/cellText';

interface ContentTableProps {
  tableData: Record<string, unknown>[];
  nodeId?: string;
}

const ContentTable = memo(({ tableData, nodeId = '' }: ContentTableProps) => {
  const columns = useMemo(() => {
    if (tableData.length === 0) return [];
    return Object.keys(tableData[0]);
  }, [tableData]);

  return (
    // Both axes, not just the vertical one: the Simple View node had the
    // identical #203 defect as the Data Pool.
    <div className="nowheel" style={{ overflow: 'auto', height: '100%' }}>
      <TableContainer component={Paper} sx={{ overflowX: 'visible' }}>
        <Table aria-label="simple table" sx={{ minWidth: 'max-content' }}>
          {columns.length > 0 && (
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    style={{ fontWeight: 'bold' }}
                    key={`cell_header_${index}_${nodeId}`}
                    align="right"
                  >
                    {column}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
          )}

          <TableBody>
            {tableData.slice(0, 100).map((row, rowIndex) => (
              <TableRow
                key={`row_${rowIndex}_${nodeId}`}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                {columns.map((column, colIndex) => (
                  // A geometry reads as WKT and any other object as JSON, as
                  // in the preview tables, not "[object Object]" (#443).
                  <TableCell key={`cell_${colIndex}_${rowIndex}_${nodeId}`} align="right">
                    {row[column] != null ? shortenString(cellText(row[column])) : 'null'}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
});

ContentTable.displayName = 'ContentTable';

export default ContentTable;
